import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix leaflet default icon issue in React
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

export default function MapView({ listings }) {
  return (
    <MapContainer
      center={[35.2271, -80.8431]} // Charlotte, NC center
      zoom={12}
      style={{ height: '500px', width: '100%', borderRadius: '8px' }}
      className="map-container"
    >
      <TileLayer
        attribution='&copy; OpenStreetMap contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      {listings.map((listing) => (
        <Marker
          key={listing.id}
          position={[listing.latitude || 35.2271, listing.longitude || -80.8431]}
        >
          <Popup>
            <strong>{listing.title}</strong>
            <br />
            {listing.description}
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}
